<template>
  <div class="container-fluid pb-4">
    <div v-if="loading" class="text-muted">Загрузка...</div>
    <div v-else>
      <div class="card">
        <div class="card-header d-flex align-items-center flex-wrap">
          <span class="text-caps">Динамика баланса</span>
          <div class="d-flex align-items-center ml-auto flex-wrap balance-range">
            <label class="mb-0 mr-2 text-nowrap">От</label>
            <datepicker
              v-model="filters.from"
              class="balance-range__input mr-3"
            />
            <label class="mb-0 mr-2 text-nowrap">До</label>
            <datepicker
              v-model="filters.to"
              class="balance-range__input mr-3"
            />
            <el-select v-model="days" size="mini" class="w-auto mr-2">
              <el-option :value="7" label="7 дней"/>
              <el-option :value="14" label="14 дней"/>
              <el-option :value="30" label="30 дней"/>
              <el-option :value="90" label="90 дней"/>
            </el-select>
            <button
              class="btn btn-link p-0 balance-range__reset"
              type="button"
              @click="clearRange"
            >Сбросить даты</button>
          </div>
        </div>
        <div class="card-body">
          <balance-history-chart
            v-if="region"
            :endpoint="balanceEndpoint"
            :days="days"
            :from="filters.from"
            :to="filters.to"
          />
          <div v-else class="text-muted">Организация не найдена</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BalanceHistoryChart from '@/components/billing/balance-history-chart.vue'
  import Datepicker from '@/components/datepicker.vue'

  export default {
    components: { BalanceHistoryChart, Datepicker },
    props: {
      region: {
        type: Object,
        default: null,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        days: 30,
        filters: {
          from: null,
          to: null,
        },
      }
    },
    computed: {
      balanceEndpoint () {
        const id = this.$route.params.region_id
        return `billing/balance/history/${id}`
      },
    },
    methods: {
      clearRange () {
        this.filters.from = null
        this.filters.to = null
      },
    },
  }
</script>

<style lang="scss" scoped>
  .balance-range__input {
    width: 150px;
  }

  .balance-range__reset {
    font-size: 0.875rem;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/billing/organization/charts.vue